var _path, _g, _g2, _path2, _path3, _g3, _path4, _path5, _path6, _g4, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImozeIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 21C0 9.40202 9.40202 0 21 0C32.598 0 42 9.40202 42 21C42 32.598 32.598 42 21 42C9.40202 42 0 32.598 0 21Z",
    fill: "#7C63A4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_iiii_2196_93156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9979 28.2833C26.0794 28.2833 30.1989 24.4143 30.1989 19.6416C30.1989 14.869 26.0794 11 20.9979 11C15.9163 11 11.7969 14.869 11.7969 19.6416C11.7969 24.4143 15.9163 28.2833 20.9979 28.2833Z",
    fill: "url(#paint0_radial_2196_93156)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9979 28.2833C26.0794 28.2833 30.1989 24.4143 30.1989 19.6416C30.1989 14.869 26.0794 11 20.9979 11C15.9163 11 11.7969 14.869 11.7969 19.6416C11.7969 24.4143 15.9163 28.2833 20.9979 28.2833Z",
    fill: "url(#paint1_radial_2196_93156)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9979 28.2833C26.0794 28.2833 30.1989 24.4143 30.1989 19.6416C30.1989 14.869 26.0794 11 20.9979 11C15.9163 11 11.7969 14.869 11.7969 19.6416C11.7969 24.4143 15.9163 28.2833 20.9979 28.2833Z",
    fill: "url(#paint2_radial_2196_93156)",
    fillOpacity: 0.4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_2196_93156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.8055 21.0658C22.8237 22.7971 19.4979 22.7656 16.5161 21.0658C16.172 20.8455 15.828 21.2232 16.0956 21.538C17.013 22.7656 18.848 23.8674 21.1799 23.8674C23.5118 23.8674 25.3468 22.7656 26.2643 21.538C26.4554 21.2232 26.1496 20.877 25.8055 21.0658Z",
    fill: "#9F5600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8055 21.0658C22.8237 22.7971 19.4979 22.7656 16.5161 21.0658C16.172 20.8455 15.828 21.2232 16.0956 21.538C17.013 22.7656 18.848 23.8674 21.1799 23.8674C23.5118 23.8674 25.3468 22.7656 26.2643 21.538C26.4554 21.2232 26.1496 20.877 25.8055 21.0658Z",
    fill: "url(#paint3_radial_2196_93156)",
    fillOpacity: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ddii_2196_93156)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3621 17.8341C26.3017 17.8614 26.2371 17.8744 26.1738 17.8744C26.0189 17.8744 25.8699 17.7968 25.7961 17.662C25.7931 17.6566 25.4631 17.1062 24.4852 17.1062C23.5229 17.1062 23.1907 17.6355 23.1721 17.6666C23.0662 17.8529 22.8155 17.929 22.6083 17.8341C22.4002 17.7392 22.3153 17.5084 22.4196 17.3186C22.4415 17.2786 22.9754 16.3379 24.4852 16.3379C25.9944 16.3379 26.5288 17.2783 26.5507 17.3186C26.655 17.5084 26.5706 17.7392 26.3621 17.8341Z",
    fill: "#5A3A13"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.3621 17.8341C26.3017 17.8614 26.2371 17.8744 26.1738 17.8744C26.0189 17.8744 25.8699 17.7968 25.7961 17.662C25.7931 17.6566 25.4631 17.1062 24.4852 17.1062C23.5229 17.1062 23.1907 17.6355 23.1721 17.6666C23.0662 17.8529 22.8155 17.929 22.6083 17.8341C22.4002 17.7392 22.3153 17.5084 22.4196 17.3186C22.4415 17.2786 22.9754 16.3379 24.4852 16.3379C25.9944 16.3379 26.5288 17.2783 26.5507 17.3186C26.655 17.5084 26.5706 17.7392 26.3621 17.8341Z",
    fill: "url(#paint4_radial_2196_93156)",
    style: {
      mixBlendMode: "soft-light"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_ddii_2196_93156)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2086 17.9763C16.2747 18.0062 16.3454 18.0205 16.4148 18.0205C16.5844 18.0205 16.7475 17.9355 16.8284 17.7879C16.8317 17.782 17.1931 17.1792 18.2639 17.1792C19.3177 17.1792 19.6814 17.7589 19.7018 17.7929C19.8178 17.9969 20.0923 18.0802 20.3192 17.9763C20.5471 17.8724 20.64 17.6196 20.5258 17.4118C20.5018 17.3681 19.9171 16.3379 18.2639 16.3379C16.6112 16.3379 16.0261 17.3676 16.002 17.4118C15.8879 17.6196 15.9803 17.8724 16.2086 17.9763Z",
    fill: "#5A3A13"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.2086 17.9763C16.2747 18.0062 16.3454 18.0205 16.4148 18.0205C16.5844 18.0205 16.7475 17.9355 16.8284 17.7879C16.8317 17.782 17.1931 17.1792 18.2639 17.1792C19.3177 17.1792 19.6814 17.7589 19.7018 17.7929C19.8178 17.9969 20.0923 18.0802 20.3192 17.9763C20.5471 17.8724 20.64 17.6196 20.5258 17.4118C20.5018 17.3681 19.9171 16.3379 18.2639 16.3379C16.6112 16.3379 16.0261 17.3676 16.002 17.4118C15.8879 17.6196 15.9803 17.8724 16.2086 17.9763Z",
    fill: "url(#paint5_radial_2196_93156)",
    style: {
      mixBlendMode: "soft-light"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_iiii_2196_93156)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8167 24.1701C17.126 24.6361 18.6031 26.4454 18.7539 26.9818C18.9067 27.5199 18.8397 28.0901 18.5655 28.5867L18.4777 28.7404C18.1827 29.2634 17.6715 29.6583 17.0565 29.8383C16.4416 30.0182 15.7733 29.9685 15.1986 29.6999L12.3111 28.3496C12.0459 28.2249 11.9413 27.9286 12.0769 27.6865C12.1418 27.57 12.2559 27.4824 12.3932 27.4439C12.5293 27.4024 12.6781 27.413 12.8055 27.4733L12.0833 27.1357C11.8181 27.0109 11.7134 26.7146 11.8491 26.4726C11.9139 26.356 12.0281 26.2684 12.1653 26.23C12.3015 26.1884 12.4504 26.199 12.5779 26.2593L12.0962 26.0344C11.8312 25.9094 11.7266 25.6132 11.8619 25.3711C12 25.1306 12.3246 25.0356 12.5907 25.1578L13.0721 25.3828C12.8069 25.258 12.7022 24.9617 12.8379 24.7196C12.9759 24.4792 13.3004 24.3843 13.5665 24.5065L16.749 25.9937L15.8859 24.6766C15.7323 24.4429 15.8159 24.1402 16.0727 24.0004C16.3294 23.8606 16.6621 23.9367 16.8156 24.1704L16.8167 24.1701Z",
    fill: "url(#paint6_radial_2196_93156)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8167 24.1701C17.126 24.6361 18.6031 26.4454 18.7539 26.9818C18.9067 27.5199 18.8397 28.0901 18.5655 28.5867L18.4777 28.7404C18.1827 29.2634 17.6715 29.6583 17.0565 29.8383C16.4416 30.0182 15.7733 29.9685 15.1986 29.6999L12.3111 28.3496C12.0459 28.2249 11.9413 27.9286 12.0769 27.6865C12.1418 27.57 12.2559 27.4824 12.3932 27.4439C12.5293 27.4024 12.6781 27.413 12.8055 27.4733L12.0833 27.1357C11.8181 27.0109 11.7134 26.7146 11.8491 26.4726C11.9139 26.356 12.0281 26.2684 12.1653 26.23C12.3015 26.1884 12.4504 26.199 12.5779 26.2593L12.0962 26.0344C11.8312 25.9094 11.7266 25.6132 11.8619 25.3711C12 25.1306 12.3246 25.0356 12.5907 25.1578L13.0721 25.3828C12.8069 25.258 12.7022 24.9617 12.8379 24.7196C12.9759 24.4792 13.3004 24.3843 13.5665 24.5065L16.749 25.9937L15.8859 24.6766C15.7323 24.4429 15.8159 24.1402 16.0727 24.0004C16.3294 23.8606 16.6621 23.9367 16.8156 24.1704L16.8167 24.1701Z",
    fill: "url(#paint7_radial_2196_93156)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8167 24.1701C17.126 24.6361 18.6031 26.4454 18.7539 26.9818C18.9067 27.5199 18.8397 28.0901 18.5655 28.5867L18.4777 28.7404C18.1827 29.2634 17.6715 29.6583 17.0565 29.8383C16.4416 30.0182 15.7733 29.9685 15.1986 29.6999L12.3111 28.3496C12.0459 28.2249 11.9413 27.9286 12.0769 27.6865C12.1418 27.57 12.2559 27.4824 12.3932 27.4439C12.5293 27.4024 12.6781 27.413 12.8055 27.4733L12.0833 27.1357C11.8181 27.0109 11.7134 26.7146 11.8491 26.4726C11.9139 26.356 12.0281 26.2684 12.1653 26.23C12.3015 26.1884 12.4504 26.199 12.5779 26.2593L12.0962 26.0344C11.8312 25.9094 11.7266 25.6132 11.8619 25.3711C12 25.1306 12.3246 25.0356 12.5907 25.1578L13.0721 25.3828C12.8069 25.258 12.7022 24.9617 12.8379 24.7196C12.9759 24.4792 13.3004 24.3843 13.5665 24.5065L16.749 25.9937L15.8859 24.6766C15.7323 24.4429 15.8159 24.1402 16.0727 24.0004C16.3294 23.8606 16.6621 23.9367 16.8156 24.1704L16.8167 24.1701Z",
    fill: "url(#paint8_radial_2196_93156)",
    fillOpacity: 0.4
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.463 26.7662C15.4308 26.8252 15.3738 26.8699 15.3049 26.8901C15.236 26.9103 15.1611 26.9042 15.0971 26.8733L11.8628 25.3619C11.9262 25.2483 12.0379 25.1632 12.172 25.1265C12.3085 25.0842 12.458 25.0947 12.5858 25.1555L15.3462 26.4356C15.4784 26.4978 15.5306 26.6455 15.463 26.7662Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9673 27.6396C14.9346 27.698 14.8773 27.7419 14.8084 27.7611C14.7401 27.7815 14.6656 27.7763 14.6015 27.7466L11.8472 26.4595C11.9112 26.3453 12.0239 26.26 12.1589 26.2235C12.2947 26.1819 12.4433 26.1926 12.5702 26.2532L14.8505 27.309C14.9827 27.3712 15.0349 27.5189 14.9673 27.6396Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7152 28.6348C14.6456 28.7552 14.483 28.8028 14.3493 28.7418L12.0777 27.6783C12.1403 27.5642 12.2523 27.4789 12.3868 27.443C12.5225 27.4005 12.6715 27.4113 12.7981 27.4727L14.5976 28.3018C14.7306 28.3646 14.7831 28.5132 14.7152 28.6348Z",
    fill: "black",
    fillOpacity: 0.2
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_iiii_2196_93156)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1833 24.1701C24.874 24.6361 23.3969 26.4454 23.2461 26.9818C23.0933 27.5199 23.1603 28.0901 23.4345 28.5867L23.5223 28.7404C23.8173 29.2634 24.3285 29.6583 24.9435 29.8383C25.5584 30.0182 26.2267 29.9685 26.8014 29.6999L29.6889 28.3496C29.9541 28.2249 30.0587 27.9286 29.9231 27.6865C29.8582 27.57 29.7441 27.4824 29.6068 27.4439C29.4707 27.4024 29.3219 27.413 29.1945 27.4733L29.9167 27.1357C30.1819 27.0109 30.2866 26.7146 30.1509 26.4726C30.0861 26.356 29.9719 26.2684 29.8347 26.23C29.6985 26.1884 29.5496 26.199 29.4221 26.2593L29.9038 26.0344C30.1688 25.9094 30.2734 25.6132 30.1381 25.3711C30 25.1306 29.6754 25.0356 29.4093 25.1578L28.9279 25.3828C29.1931 25.258 29.2978 24.9617 29.1621 24.7196C29.0241 24.4792 28.6996 24.3843 28.4335 24.5065L25.251 25.9937L26.1141 24.6766C26.2677 24.4429 26.1841 24.1402 25.9273 24.0004C25.6706 23.8606 25.3379 23.9367 25.1844 24.1704L25.1833 24.1701Z",
    fill: "url(#paint9_radial_2196_93156)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1833 24.1701C24.874 24.6361 23.3969 26.4454 23.2461 26.9818C23.0933 27.5199 23.1603 28.0901 23.4345 28.5867L23.5223 28.7404C23.8173 29.2634 24.3285 29.6583 24.9435 29.8383C25.5584 30.0182 26.2267 29.9685 26.8014 29.6999L29.6889 28.3496C29.9541 28.2249 30.0587 27.9286 29.9231 27.6865C29.8582 27.57 29.7441 27.4824 29.6068 27.4439C29.4707 27.4024 29.3219 27.413 29.1945 27.4733L29.9167 27.1357C30.1819 27.0109 30.2866 26.7146 30.1509 26.4726C30.0861 26.356 29.9719 26.2684 29.8347 26.23C29.6985 26.1884 29.5496 26.199 29.4221 26.2593L29.9038 26.0344C30.1688 25.9094 30.2734 25.6132 30.1381 25.3711C30 25.1306 29.6754 25.0356 29.4093 25.1578L28.9279 25.3828C29.1931 25.258 29.2978 24.9617 29.1621 24.7196C29.0241 24.4792 28.6996 24.3843 28.4335 24.5065L25.251 25.9937L26.1141 24.6766C26.2677 24.4429 26.1841 24.1402 25.9273 24.0004C25.6706 23.8606 25.3379 23.9367 25.1844 24.1704L25.1833 24.1701Z",
    fill: "url(#paint10_radial_2196_93156)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1833 24.1701C24.874 24.6361 23.3969 26.4454 23.2461 26.9818C23.0933 27.5199 23.1603 28.0901 23.4345 28.5867L23.5223 28.7404C23.8173 29.2634 24.3285 29.6583 24.9435 29.8383C25.5584 30.0182 26.2267 29.9685 26.8014 29.6999L29.6889 28.3496C29.9541 28.2249 30.0587 27.9286 29.9231 27.6865C29.8582 27.57 29.7441 27.4824 29.6068 27.4439C29.4707 27.4024 29.3219 27.413 29.1945 27.4733L29.9167 27.1357C30.1819 27.0109 30.2866 26.7146 30.1509 26.4726C30.0861 26.356 29.9719 26.2684 29.8347 26.23C29.6985 26.1884 29.5496 26.199 29.4221 26.2593L29.9038 26.0344C30.1688 25.9094 30.2734 25.6132 30.1381 25.3711C30 25.1306 29.6754 25.0356 29.4093 25.1578L28.9279 25.3828C29.1931 25.258 29.2978 24.9617 29.1621 24.7196C29.0241 24.4792 28.6996 24.3843 28.4335 24.5065L25.251 25.9937L26.1141 24.6766C26.2677 24.4429 26.1841 24.1402 25.9273 24.0004C25.6706 23.8606 25.3379 23.9367 25.1844 24.1704L25.1833 24.1701Z",
    fill: "url(#paint11_radial_2196_93156)",
    fillOpacity: 0.4
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.537 26.7662C26.5692 26.8252 26.6262 26.8699 26.6951 26.8901C26.764 26.9103 26.8389 26.9042 26.9029 26.8733L30.1372 25.3619C30.0738 25.2483 29.9621 25.1632 29.828 25.1265C29.6915 25.0842 29.542 25.0947 29.4142 25.1555L26.6538 26.4356C26.5216 26.4978 26.4694 26.6455 26.537 26.7662Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0327 27.6396C27.0654 27.698 27.1227 27.7419 27.1916 27.7611C27.2599 27.7815 27.3344 27.7763 27.3985 27.7466L30.1528 26.4595C30.0888 26.3453 29.9761 26.26 29.8411 26.2235C29.7053 26.1819 29.5567 26.1926 29.4298 26.2532L27.1495 27.309C27.0173 27.3712 26.9651 27.5189 27.0327 27.6396Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2848 28.6348C27.3544 28.7552 27.517 28.8028 27.6507 28.7418L29.9223 27.6783C29.8597 27.5642 29.7477 27.4789 29.6132 27.443C29.4775 27.4005 29.3285 27.4113 29.2019 27.4727L27.4024 28.3018C27.2694 28.3646 27.2169 28.5132 27.2848 28.6348Z",
    fill: "black",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_iiii_2196_93156",
    x: 11.7969,
    y: 8.47042,
    width: 18.4023,
    height: 19.8128,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2.52958
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.26479
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.741667 0 0 0 0 0.356 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2196_93156"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.758873
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.379436
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.741176 0 0 0 0 0.356863 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2196_93156",
    result: "effect2_innerShadow_2196_93156"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.758873
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.776471 0 0 0 0 0.278431 0 0 0 0 0 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_2196_93156",
    result: "effect3_innerShadow_2196_93156"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.758873
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.379436
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_2196_93156",
    result: "effect4_innerShadow_2196_93156"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_2196_93156",
    x: 16,
    y: 21,
    width: 10.3232,
    height: 6.86719,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2196_93156"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2196_93156",
    result: "effect2_innerShadow_2196_93156"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ddii_2196_93156",
    x: 21.9507,
    y: 16.0069,
    width: 5.06932,
    height: 2.4515,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.159116
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.212155
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.520833 0 0 0 0 0.0740885 0 0 0 0 0.0455729 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2196_93156"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.0530387
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.159116
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.225 0 0 0 0 0.0874875 0 0 0 0 0.0440625 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2196_93156",
    result: "effect2_dropShadow_2196_93156"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2196_93156",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.318232
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.318232
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.629167 0 0 0 0 0.206786 0 0 0 0 0.0734028 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_2196_93156"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.330961
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.330961
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.956863 0 0 0 0 0.72549 0 0 0 0 0.639216 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_2196_93156",
    result: "effect4_innerShadow_2196_93156"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_ddii_2196_93156",
    x: 15.5288,
    y: 16.0069,
    width: 5.46971,
    height: 2.59798,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.159116
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.212155
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.520833 0 0 0 0 0.0740885 0 0 0 0 0.0455729 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2196_93156"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.0530387
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.159116
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.225 0 0 0 0 0.0874875 0 0 0 0 0.0440625 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2196_93156",
    result: "effect2_dropShadow_2196_93156"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2196_93156",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.318232
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.318232
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.629167 0 0 0 0 0.206786 0 0 0 0 0.0734028 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_2196_93156"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.330961
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.330961
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.956863 0 0 0 0 0.72549 0 0 0 0 0.639216 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_2196_93156",
    result: "effect4_innerShadow_2196_93156"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_iiii_2196_93156",
    x: 11.79,
    y: 21.4001,
    width: 7.04395,
    height: 8.5452,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2.52958
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.26479
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.741667 0 0 0 0 0.356 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2196_93156"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.758873
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.379436
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.741176 0 0 0 0 0.356863 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2196_93156",
    result: "effect2_innerShadow_2196_93156"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.758873
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.776471 0 0 0 0 0.278431 0 0 0 0 0 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_2196_93156",
    result: "effect3_innerShadow_2196_93156"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.758873
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.379436
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_2196_93156",
    result: "effect4_innerShadow_2196_93156"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_iiii_2196_93156",
    x: 23.166,
    y: 21.4001,
    width: 7.04395,
    height: 8.5452,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2.52958
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.26479
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.741667 0 0 0 0 0.356 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2196_93156"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.758873
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.379436
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.741176 0 0 0 0 0.356863 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2196_93156",
    result: "effect2_innerShadow_2196_93156"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.758873
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.776471 0 0 0 0 0.278431 0 0 0 0 0 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_2196_93156",
    result: "effect3_innerShadow_2196_93156"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.758873
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.379436
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_2196_93156",
    result: "effect4_innerShadow_2196_93156"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2196_93156",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.8605 14.9984) rotate(90) scale(5.0302 5.3558)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC533"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2196_93156",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.2163 21.1894) rotate(173.09) scale(4.28832 4.03541)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5C28",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2196_93156",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.4569 21.4301) rotate(32.0522) scale(3.6294 3.53706)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5C28",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2196_93156",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.0241 21.6595) rotate(90) scale(2.21743 12.6494)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2196_93156",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.9483 16.6538) rotate(41.8703) scale(1.46781 2.00952)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_2196_93156",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.676 16.6839) rotate(41.8703) scale(1.60733 2.20053)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_2196_93156",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.648 25.5444) rotate(70.5448) scale(1.81926 1.94653)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC533"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_2196_93156",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.2648 27.1082) rotate(156.789) scale(1.55057 1.467)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5C28",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_2196_93156",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.8844 28.1879) rotate(14.6829) scale(1.35076 1.24924)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5C28",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_2196_93156",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.352 25.5444) rotate(109.455) scale(1.81926 1.94653)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC533"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_2196_93156",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.7352 27.1082) rotate(23.2113) scale(1.55057 1.467)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5C28",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_2196_93156",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.1156 28.1879) rotate(165.317) scale(1.35076 1.24924)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5C28",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImozeIcons);
export default __webpack_public_path__ + "static/media/imoze-icons.fb1bfc0f6da83d8fb58e9b72d293cea3.svg";
export { ForwardRef as ReactComponent };